export default "__VITE_ASSET__mV8V70rB__"